import { withJsonFormsControlProps } from '@jsonforms/react';
import { Money } from './Money';

const MoneyControl = ({ data, handleChange, path, schema, errors, visible, label }) => {
  return (
    <Money
      value={data}
      updateValue={(newValue) => handleChange(path, newValue)}
      path={path}
      description={schema?.description ?? ''}
      errors={errors}
      visible={visible}
      label={label}
    />
  );
};

export default withJsonFormsControlProps(MoneyControl);
